/**
 * 需要把util中的方法添加到过滤器的，只需要直接在该页面添加Vue.filter(过滤器名， 方法名)
 */
import util from '@/plugins/util'

export default {
  install (Vue, option) {
    Vue.filter('formatPhone', util.formatPhone)
    Vue.filter('formatCount', util.formatCount)
    Vue.filter('formatZero', util.formatZero)
    Vue.filter('formatCourseInfo', util.formatCourseInfo)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/filter/index.js